import { Component, input, OnInit } from '@angular/core';
import { FormAreaComponent } from "../form-area/form-area.component";
import { InputComponent } from "../input/input.component";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-email-form',
  standalone: true,
  imports: [
    FormAreaComponent,
    InputComponent,
    MatSlideToggle,
    TranslateModule
  ],
  templateUrl: './email-form.component.html',
})
export class EmailFormComponent implements OnInit {
  control = input.required<any>();
  disabled = input<boolean>(false);

  ngOnInit(): void {
    const emailControl = this.control().get('email');

    if (this.disabled()) {
      emailControl?.disable({ emitEvent: false });
    }
  }
}
